import script from "./Tags.vue?vue&type=script&setup=true&lang=js"
export * from "./Tags.vue?vue&type=script&setup=true&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=1880e380&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1880e380"]])

export default __exports__